import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  BatteryCreditHumanApplicationHandoffDto,
  ReplaceBatteryCreditHumanApplicationDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Replace the current Credit Human Existing Loan Application from the exact
 * current Quote. Retries with the same idempotency key return the same attempt.
 */
export default function useReplaceBatteryCreditHumanApplication(): UseMutationResult<
  BatteryCreditHumanApplicationHandoffDto,
  unknown,
  {
    proposalId: string
    applicationId: string
    body: ReplaceBatteryCreditHumanApplicationDto
  }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId, body }) =>
      batteryProposalService.replaceCreditHumanApplication(
        proposalId,
        applicationId,
        body,
      ),
    onSuccess: (handoff, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        handoff.financing,
      )
    },
  })
}
